import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RedirectUrlService {
    _url = new BehaviorSubject("");

    constructor() {
    }


}
